import { createApi } from '@reduxjs/toolkit/query/react';
import { webapiBaseQuery } from './baseQuery';

/**
 * WebAPI — Client mode API
 *
 * This is the sole API used by the client (Auth0) frontend mode.
 * It replaces the multiple APIs (eventSourceApi, portalApi) used in agent mode.
 *
 * Endpoints are injected per feature using `webapiApi.injectEndpoints()`.
 */
export const webapiApi = createApi({
  reducerPath: 'webapiApi',
  baseQuery: webapiBaseQuery,
  tagTypes: [
    'InboundOrder',
    'OutboundOrder',
    'RoadTransport',
    'Port',
    'ErpIntegration',
    'TrackingCode',
    'AddressBook',
    'Stock',
    'StockMovement',
    'EmailSchedule',
    'User',
    'Tenant',
    'Invitation',
    'Announcement',
    'Container',
  ],
  endpoints: () => ({}),
});
